// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/CollectionLabel/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Payors_Content_Payors_Payor_Content_Content_CollectionLabel($patient_id: numeric!, $payment_account_id: numeric!) {
  vaxiom_collection_labels_by_pk(
    patient_id: $patient_id
    payment_account_id: $payment_account_id
  ) {
    patient_id
    payment_account_id
    collection_label_template {
      id
      name
      agency {
        id
        name
        phone_numer
      }
    }
  }
}

`